import React, { Component } from "react";
import "../css/home.css";
import { ProjectService } from "../Services/ProjectService";
import {toInt, getTimeInIST, format_display, getProjectStatusBadge} from '../Utils';
import Paper from '@material-ui/core/Paper';
import EnhancedTableHead from '../components/EnhancedTableHead';
import TableBody from '@material-ui/core/TableBody';
import { withStyles } from '@material-ui/core/styles';
import TablePagination from '@material-ui/core/TablePagination';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { RowCountOptions } from "../Config";
import Typography from '@material-ui/core/Typography';
import TableHead from '@material-ui/core/TableHead';
import classnames from 'classnames';

import Badge from '@material-ui/core/Badge';
import { ItemService } from "../Services/ItemService";

const styles = theme =>({
  fab: {
      margin: theme.spacing.unit,
      position: 'absolute',
      bottom: theme.spacing.unit * 2,
      right: theme.spacing.unit * 2,
  },
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto',
    paddingTop : theme.spacing.unit, 
    paddingLeft: theme.spacing.unit, 
    paddingRight: theme.spacing.unit,
    paddingBottom: theme.spacing.unit
  },
  tablecell: {
      fontSize: '12pt',
      padding: theme.spacing.unit * 2
  },
  paper: {
      position: 'absolute',
      backgroundColor: theme.palette.background.paper,
      boxShadow: theme.shadows[5],
      padding: theme.spacing.unit * 4,
      width: "80%",
      outline: 'none',
      textAlign: 'center',
      color: theme.palette.text.secondary,
      marginBottom : '20px',
  },
  table: {
      minWidth: 700
  },
  list: {
      width: '100%',
      backgroundColor: theme.palette.background.paper
  },
  grid: {
      [theme.breakpoints.up('md')]: {
          marginTop: '10px',
      },
      marginTop: '50px',
      marginBottom: '5px'
  },
  textField: {
      marginLeft: theme.spacing.unit,
      marginRight: theme.spacing.unit,
  },
  qtyField: {
      width: "40%",
      position: "relative",
      [theme.breakpoints.up('md')]: {
          right: '100px',
          width: "30%",
      },
      right: "22px"
  },
  icon: {
      padding: '0px',
      [theme.breakpoints.up('md')]: {
          padding: '12px',
      },
  },
  itemQtySection: {
    width: '100%',
    [theme.breakpoints.up('md')]: {
        width: '40%',
    },
  }
});

class Home extends Component {

  constructor(props) {
    super(props);
    this.state = {
      data: [],
      originalData: [],
      current_rows: [],
      numItemsPerPage: 10,
      currentPageNumber: 0,
      totalItems: 0,
      totalPages: 0,
      columns : [
        { id: 'name', numeric: false, disablePadding: true, label: 'Name', sortable: true },
        { id: 'qty', numeric: false, disablePadding: true, label: 'Quantity' , sortable: true },
        { id: 'status', numeric: false, disablePadding: true, label: 'Status', sortable: true  },
        { id: 'created_date', numeric: false, disablePadding: true, label: 'Start Date', sortable: true  },
        { id: 'created_by', numeric: false, disablePadding: true, label: 'Created By', sortable: true  },
      ],
      order: 'asc',
      orderBy: 'name',
      status_badge: '',
      items: []
    }
  }

  componentWillMount(){
    this.props.setTitle('Dashboard');
    this.props.isLoading(true);
    ProjectService.getTotalCount(false)
    .then((data) => {
        this.setState({
            totalItems: toInt(data.count), 
            totalPages: Math.ceil(data.count / this.state.numItemsPerPage) - 1
        });
        this.props.isLoading(false);
    })
    .catch(error => {
        console.log(error);
        this.props.isLoading(false);
    });

    ProjectService.getTotalCount(true)
    .then((data) => {
        let status_badge = data.count.map(element => (
          <Badge key={element.status} badgeContent={toInt(element.count)} style={{marginRight: '20px'}} color="secondary">
            {getProjectStatusBadge(element.status)}
          </Badge>
        ));
        this.setState({ status_badge: status_badge });
        this.props.isLoading(false);
    })
    .catch(error => {
        console.log(error);
        this.props.isLoading(false);
    });
  }

  componentDidMount(){
    this.fetchData(0, this.state.numItemsPerPage);
    this.fetchItems();
  }

  fetchItems = () => {
        ItemService.getItemList()
        .then((data) => {
            let items = data.items.filter(i => i.stock <= i.threshold);
            this.setState({items: items});
        })
        .catch(error => {
            console.log('failed to fetch Items');
        })
  }

  sortBy = (event, property) => {
    const orderBy = property;
    let order = 'desc';

    if (this.state.orderBy === property && this.state.order === 'desc') {
      order = 'asc';
    }

    this.setState({ order, orderBy }, () => this.fetchData(0, this.state.numItemsPerPage, ''));
  }

  handleChangeRowsPerPage = event => {
      this.setState({ numItemsPerPage : event.target.value }, () => this.fetchData(0, this.state.numItemsPerPage, ''));
  }

  handleChangePage = (event, page) => {
      if(this.state.currentPageNumber > page){
          this.fetchRow(this.state.currentPageNumber - 1);
      } else {
          this.fetchRow(this.state.currentPageNumber + 1);
      }
  };

  fetchData(start, numberItems, filter = ''){
    this.props.isLoading(true);
    let rows = [];
    let sort = this.state.orderBy ? this.state.orderBy : '', direction = this.state.order ? this.state.order : '';
    let statuses = this.state.statuses ? this.state.statuses.join(',') : [0, 1, 2].join(',');
    ProjectService.getProjectList(start, numberItems, filter, statuses, sort, direction)
    .then((data) => {
        this.setState({data: data.projects, originalData: data.projects});
        if(data.projects){
            data.projects.forEach((project) => {
                rows.push(<ProjectDetails key={project.id} project={project} changeStatus={this.changeStatus} edit={this.newProject} remove={this.removeProject}/>);
            });
            this.setState({
                current_rows: rows
            });
        }
        
        this.props.isLoading(false);
    })
    .catch(error => {
        console.log(error);
        this.props.isLoading(false);
    });
  }

  handleSelect(eventKey, e) {
    if(eventKey === 'prev'){
        if((this.state.currentPageNumber) > 0){
            this.fetchRow(this.state.currentPageNumber - 1);
        }
    } else if(eventKey === 'next'){
        if((this.state.currentPageNumber) < this.state.totalPages){
            this.fetchRow(this.state.currentPageNumber + 1);
        }
    }
  }

  fetchRow(newCurrentPage){
      this.fetchData(newCurrentPage * this.state.numItemsPerPage, this.state.numItemsPerPage);
      this.setState({ currentPageNumber: newCurrentPage });
  }

  render() {
    let {message, status_badge} = this.state;
    const { classes } = this.props;

    return (
      <div className="Home">
        <div className="lander">
          <h1>Dashboard</h1>
          <div className="container">
              {status_badge}
              <p style={{color:"red", paddingLeft:"20px"}}>{message}</p>
              { !message &&
                  <Paper className={this.props.classes.root} style={{width: "100%", marginTop: "5px", paddingLeft: "5px", paddingRight: "5px"}}>
                      <Table className={classes.table}>
                          <EnhancedTableHead
                              order={this.state.order}
                              orderBy={this.state.orderBy}
                              onRequestSort={this.sortBy}
                              rows ={this.state.columns} />
                          <TableBody>
                          {this.state.current_rows}
                          </TableBody>
                      </Table>
                      <TablePagination
                          rowsPerPageOptions={RowCountOptions}
                          component="div"
                          count={this.state.totalItems}
                          rowsPerPage={this.state.numItemsPerPage}
                          page={this.state.currentPageNumber}
                          backIconButtonProps={{
                              'aria-label': 'Previous Page',
                          }}
                          nextIconButtonProps={{
                              'aria-label': 'Next Page',
                          }}
                          onChangePage={this.handleChangePage}
                          onChangeRowsPerPage={this.handleChangeRowsPerPage}
                          />
                  </Paper>
              }
              { this.state.items.length > 0 &&
                <Paper className={classnames(this.props.classes.itemQtySection, this.props.classes.root)} style={{marginTop: "20px", paddingLeft: "5px", paddingRight: "5px"}}>
                    <Typography variant="h5" component="h3" align="justify" style={{marginLeft: 10}}>
                        You may fall short of the bellow items
                    </Typography>
                    <Table style={{margin: 10, width: '95%'}} padding='none'>
                        <TableHead>
                            <TableRow>
                                <TableCell className={classes.tablecell}>Item</TableCell>
                                <TableCell align="right" className={classes.tablecell}>Stock available</TableCell>
                                <TableCell align="right" className={classes.tablecell}>Threshold</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.state.items.map(item => (
                                <TableRow key={item.id} hover >
                                    <TableCell component="th" scope="row" className={classes.tablecell}>
                                        {item.name}
                                    </TableCell>
                                    <TableCell align="right" className={classes.tablecell}>
                                        <Typography variant="subtitle2" component="h6" color="secondary">
                                            {item.stock}
                                        </Typography>
                                        </TableCell>
                                    <TableCell align="right" className={classes.tablecell}>{item.threshold}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Paper>
              }
          </div>
        </div>
      </div>
    );
  }
}

class ProjectDetails extends Component {

  render(){
    const project = this.props.project;

      return (
          <TableRow key={project.id}>
              <TableCell component="th" scope="row" align="center" padding='none'>
                  <Typography variant="subtitle2">{project.name}</Typography>
                  <Typography variant="body1">({project.description})</Typography>
              </TableCell>
              <TableCell align="center"  padding='none'><Typography variant="subtitle2">{project.qty}</Typography></TableCell>
              <TableCell align="center"  padding='none'>
                  {getProjectStatusBadge(project.status)}
              </TableCell>
              <TableCell align="center"  padding='none'>{getTimeInIST(project.created_date).format(format_display)}</TableCell>
              <TableCell align="center"  padding='none'>{project.created_by}</TableCell>
          </TableRow>
      );
  }
}

export default withStyles(styles)(Home);